<template>
  <div
    :style="{'--Drawer-animation-duration': `${animationDuration}s` }"
    :class="{
      [$style['Drawer__Container']]: true,
      [$style['Drawer__Container--global']]: overlay && !inline,
      [$style['Drawer__Container--globalInline']]: overlay && inline,
      [$style['Drawer__Container--inline']]: !overlay,
    }"
  >
    <slot />
    <Transition :name="`drawer-${position}`">
      <div
        :class="{
          [$style['Drawer__Pane']]: true,
          [$style[`Drawer__Pane--${position}`]]: true,
        }"
        v-if="active">
        <slot name="content" />
      </div>
    </Transition>
    <Transition name="overlay" v-if="overlay">
      <div
        :class="{
          [$style['Drawer__Overlay']]: true,
          [$style['Drawer__Overlay--inline']]: inline,
        }"
        @click="handleClose"
        v-if="active"
      />
    </Transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    active: {
      type: Boolean,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    position: {
      validator (value) {
        return ['left', 'top', 'right', 'bottom'].includes(value);
      },
      required: true,
    },
    animationDuration: {
      type: Number,
      default: 0.5,
    },
  },
  emits: ['change'],
  setup (props, { emit }) {

    return {
      handleClose () {
        emit('change', false);
      },
    };
  },
});
</script>

<style lang="less" module>
.Drawer {
  &__Container {
    height: 100%;
    &--global {
      --Drawer-position: fixed;
    }
    &--globalInline {
      --Drawer-position: relative;
    }
    &--inline {
      --Drawer-position: static;
    }
    &:focus-visible {
      outline: 0 none;
    }
  }
  &__Pane {
    position: var(--Drawer-position);
    z-index: 1000;
    &--left {
      height: 100%;
      top: 0;
      left: 0;
    }
    &--right {
      height: 100%;
      top: 0;
      right: 0;
    }
    &--top {
      left: 0;
      top: 0;
    }
    &--bottom {
      left: 0;
      bottom: 0;
    }
  }

  &__Overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.15);
    z-index: 999;
    pointer-events: auto;
    &--inline {
      background-color: rgba(0, 0, 0, 0);
    }
  }
}
</style>
<style scoped>
  .drawer-left-enter-active, .drawer-top-enter-active, .drawer-right-enter-active, .drawer-bottom-enter-active {
    transition: transform var(--Drawer-animation-duration, 0.5s) cubic-bezier(0.33, 1, 0.68, 1);
  }
  .drawer-left-leave-active, .drawer-top-leave-active, .drawer-right-leave-active, .drawer-bottom-leave-active {
    transition: transform var(--Drawer-animation-duration, 0.5s) cubic-bezier(0.33, 1, 0.68, 1);
  }
  .drawer-left-enter, .drawer-left-leave-active {
    transform: translateX(-100%);
  }
  .drawer-right-enter, .drawer-right-leave-active {
    transform: translateX(100%);
  }
  .drawer-top-enter, .drawer-top-leave-active {
    transform: translateY(-100%);
  }
  .drawer-bottom-enter, .drawer-bottom-leave-active {
    transform: translateY(100%);
  }
  .overlay-enter-active, .overlay-leave-active {
    transition: opacity var(--Drawer-animation-duration, 0.5s) cubic-bezier(0.33, 1, 0.68, 1);
  }
  .overlay-enter, .overlay-leave-active {
    opacity: 0;
  }
</style>
